export type TypedEventMap = object;

export type TypedEventListener<TDetail> = (
  event: CustomEvent<TDetail>,
) => void;

/**
 * EventTarget-compatible, viewport-local event channel with typed names/details.
 * EventTarget compatibility keeps existing registerEvents/EventListener adapters usable.
 */
export class TypedEventChannel<TEvents extends TypedEventMap>
  extends EventTarget {
  emit<TKey extends keyof TEvents & string>(
    type: TKey,
    detail: TEvents[TKey],
  ): boolean {
    return this.dispatchEvent(new CustomEvent(type, { detail }));
  }

  on<TKey extends keyof TEvents & string>(
    type: TKey,
    listener: TypedEventListener<TEvents[TKey]>,
    options?: AddEventListenerOptions | boolean,
  ): () => void {
    this.addEventListener(type, listener as EventListener, options);
    return () =>
      this.removeEventListener(type, listener as EventListener, options);
  }
}
